module.exports = __webpack_public_path__ + "static/media/5071.d440ba0e.jpg";